import { render, staticRenderFns } from "./mukayeselirapor.vue?vue&type=template&id=5ab05e96&scoped=true"
import script from "./mukayeselirapor.vue?vue&type=script&lang=js"
export * from "./mukayeselirapor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab05e96",
  null
  
)

export default component.exports